export default "__VITE_ASSET__863c5c71__"